module.exports = __webpack_public_path__ + "img/gwyx-jscbfc.8fc7a63d.png";